var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17.182 12.57"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4a4a4a",
    d: "M.272.419H16.91v12.15H.272z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.272.419l8.319 5.4 8.319-5.4",
    fill: "none",
    stroke: "#f9f9f9",
    strokeMiterlimit: 10
  })));
}
export default __webpack_public_path__ + "5e0173fb895decd069837823046527e7.svg";
export { SvgEmailIcon as ReactComponent };